/**
 * ag-footer.js
 * Web component : accordion menus mobile, ouverture forcée desktop
 */

class AgFooterMenu extends HTMLElement {
  constructor() {
    super();
    this.details = [];
    this.desktopMQ = window.matchMedia('(min-width: 990px)');
  }

  connectedCallback() {
    this.details = [...this.querySelectorAll('details.ag-footer__menu-group, details.ag-fv2__menu-group')];
    if (!this.details.length) return;

    this.handleBreakpoint = this.handleBreakpoint.bind(this);
    this.desktopMQ.addEventListener('change', this.handleBreakpoint);
    this.handleBreakpoint();
  }

  disconnectedCallback() {
    this.desktopMQ.removeEventListener('change', this.handleBreakpoint);
  }

  handleBreakpoint() {
    const isDesktop = this.desktopMQ.matches;

    for (const detail of this.details) {
      if (isDesktop) {
        detail.setAttribute('open', '');
        detail.querySelector('summary')?.setAttribute('aria-disabled', 'true');
      } else {
        detail.removeAttribute('open');
        detail.querySelector('summary')?.removeAttribute('aria-disabled');
      }
    }

    if (isDesktop) {
      this.disableToggle();
    } else {
      this.enableToggle();
    }
  }

  disableToggle() {
    for (const detail of this.details) {
      detail.addEventListener('click', this.preventToggle);
    }
  }

  enableToggle() {
    for (const detail of this.details) {
      detail.removeEventListener('click', this.preventToggle);
    }
  }

  preventToggle(e) {
    const summary = e.target.closest('summary');
    if (summary) e.preventDefault();
  }
}

if (!customElements.get('ag-footer-menu')) {
  customElements.define('ag-footer-menu', AgFooterMenu);
}
